(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ak-manual-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialise = () => {
    const dialogs = [...document.querySelectorAll('[data-ak-manual-dialog]')];
    dialogs.forEach(dialog => {
      if (dialog.dataset.initialised || typeof dialog.showModal !== 'function') return;
      dialog.dataset.initialised = 'true';
      let opener = null;
      let previousOverflow = '';
      const track = action => {
        if (window.Shopify?.customerPrivacy && !window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;
        if (!Array.isArray(window.dataLayer)) return;
        window.dataLayer.push({event: action, manual_id: dialog.dataset.manualId, manual_revision: dialog.dataset.manualRevision, product_id: dialog.dataset.productId, manual_source: new URLSearchParams(location.search).get('utm_source') === 'packaging' ? 'packaging' : 'product'});
      };
      const open = trigger => {
        if (dialog.open || document.querySelector('[data-ak-manual-dialog][open]')) return;
        opener = trigger || document.activeElement;
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
        track('manual_open');
      };
      const close = () => dialog.close();
      dialog.querySelectorAll('[data-ak-manual-close]').forEach(button => button.addEventListener('click', close));
      dialog.addEventListener('close', () => {document.documentElement.style.overflow = previousOverflow; if (opener instanceof HTMLElement && opener.isConnected) opener.focus({preventScroll:true});});
      dialog.addEventListener('click', event => {const r=dialog.getBoundingClientRect();if(event.target===dialog&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))close();});
      dialog.querySelector('[data-ak-manual-download]').addEventListener('click', () => {const notice=dialog.querySelector('[data-ak-manual-notice]');notice.textContent=notice.dataset.downloadNotice;track('manual_download_click');});
      dialog.querySelector('[data-ak-manual-view]').addEventListener('click', () => track('manual_view_click'));
      const download = dialog.querySelector('[data-ak-manual-download]');
      const links=[...document.querySelectorAll('.ak-resources__download')].filter(link => link.href === download.href);
      links.forEach(link => link.addEventListener('click', event => {if(event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;event.preventDefault();open(link);}));
      const manual = new URLSearchParams(location.search).get('manual');
      if (!window.Shopify?.designMode && (manual === '1' || manual === dialog.dataset.manualId)) open(links[0]);
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise,{once:true});else initialise();
  document.addEventListener('shopify:section:load',initialise);
})();
  } catch(e) { console.error(e); }
})();

})();
